import React from "react";
import { Link } from "react-router-dom";
import "../styles/Footer.css";
import { company } from "../data/site";

export default function Footer() {
	const year = new Date().getFullYear();
	return (
		<footer className="site-footer">
			<div className="site-footer__inner">
				<div className="site-footer__id">
					<p className="site-footer__name">{company.legalName}</p>
					<address>
						<a href={company.mapUrl} target="_blank" rel="noreferrer">
							{company.street}
							<br />
							{company.city}, {company.region} {company.postal}
						</a>
					</address>
				</div>
				<ul className="site-footer__links">
					<li>
						<a href={company.phoneHref}>{company.phone}</a>
					</li>
					<li>
						<a href={`mailto:${company.email}`}>{company.email}</a>
					</li>
				</ul>
				<ul className="site-footer__links">
					<li>
						<Link to="/services">Capabilities</Link>
					</li>
					<li>
						<Link to="/quote">Request a quote</Link>
					</li>
					<li>
						<Link to="/privacy">Privacy policy</Link>
					</li>
				</ul>
			</div>
			<p className="site-footer__legal">
				&copy; {year} {company.legalName}
			</p>
		</footer>
	);
}
